export const getGreeting = () => {
  const hours = new Date().getHours();
  if (hours < 12) {
    return 'Good morning';
  } else if (hours < 18) {
    return 'Good afternoon';
  } else if (hours < 22) {
    return 'Good evening';
  } else {
    return 'Good night';
  }
};

export const getDates = (range: string): { from: string; to: string } | null => {
  const today = new Date();

  if (range === 'last-7-days') {
    const from = new Date(today);
    from.setDate(today.getDate() - 6); // 7 days ago
    const to = today; // today
    return { from: from.toISOString().split('T')[0], to: to.toISOString().split('T')[0] }; // Format as YYYY-MM-DD
  }

  if (range === 'last-week') {
    const lastMonday = new Date(today);
    lastMonday.setDate(today.getDate() - today.getDay() - 6); // Last week's Monday
    const from = lastMonday; // Last week's Monday
    const to = new Date(lastMonday);
    to.setDate(lastMonday.getDate() + 6); // Last week's Sunday
    return { from: from.toISOString().split('T')[0], to: to.toISOString().split('T')[0] }; // Format as YYYY-MM-DD
  }

  return null;
};
